import { Component, Input } from "@angular/core";

@Component({
    selector: "web-cibil-footer",
    templateUrl: "./cibil-footer.component.html",
    styleUrls: ["./cibil-footer.component.scss"],
})
export class CibilFooterComponent {
    @Input() isNote: boolean = false;
}
